import { processQuery } from './BaseDataSources';
import { IDealBuyerInfo } from '@/Interfaces';
import { AjaxHelper, IPaginatedList, IReadOptions, Source } from '@samc/common';

export class EligibleTargetDealsSource extends Source<IDealBuyerInfo> {
  private _helper: AjaxHelper;
  private _query: Record<string, any> = {};

  public constructor(private loanIds: number[], sourceDealId: string | null = null, public buyerId: string | null = null, pageSize = 50) {
    super(pageSize);

    this._query = { sourceDealId, buyerId };
    this._helper = new AjaxHelper('datasource/eligibletargetdeals', '', '', null);
  }

  protected async getRows(options: IReadOptions, abortController: AbortController): Promise<IPaginatedList<IDealBuyerInfo>> {
    this._query.buyerId = this.buyerId;

    return await this._helper.postData<IPaginatedList<IDealBuyerInfo>>('',
      { loanIds: this.loanIds },
      { ...processQuery(options), ...this._query },
      { signal: abortController.signal });
  }
}